var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvideLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#105469;}.cls-3{opacity:0.4;}.cls-10,.cls-3{isolation:isolate;}.cls-4{fill:#1db2d5;}.cls-5{fill:#0d4f63;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#10596f;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#fff;}.cls-10{opacity:0.87;}.cls-11{opacity:0.72;}.cls-12{clip-path:url(#clip-path-3);}.cls-13{fill:#1c2938;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.35,127.81h0a3.19,3.19,0,0,1-3.19,3.19H73.86a3.19,3.19,0,0,1-3.19-3.19h0a3.19,3.19,0,0,1,3.19-3.18h29.3A3.19,3.19,0,0,1,106.35,127.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.47,49.47h0A2.55,2.55,0,0,1,136.92,52H38.82a2.54,2.54,0,0,1-2.54-2.54h0a2.55,2.55,0,0,1,2.54-2.55h98.1A2.55,2.55,0,0,1,139.47,49.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 345.01,
    y: -416.85,
    width: 1440,
    height: 800
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13925",
    "data-name": "Group 13925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17694",
    "data-name": "Rectangle 17694"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,0h0a88,88,0,0,1,88,88h0a88,88,0,0,1-88,88h0A88,88,0,0,1,0,88H0A88,88,0,0,1,88,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13705",
    "data-name": "Group 13705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 131.83,
    cy: 88.96,
    r: 11.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17679",
    "data-name": "Rectangle 17679",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.51,54.56h0a2.55,2.55,0,0,1,2.55,2.55v66.25a2.55,2.55,0,0,1-2.55,2.54h0A2.55,2.55,0,0,1,86,123.36V57.11A2.55,2.55,0,0,1,88.51,54.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13704",
    "data-name": "Group 13704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17687",
    "data-name": "Rectangle 17687"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.25,123.53v2.37H75.77v-2.37a4,4,0,0,1,4-4H97.25A4,4,0,0,1,101.25,123.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17691",
    "data-name": "Rectangle 17691"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 7,
    transform: "translate(55.24 124.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAHCAYAAACvFtvDAAAACXBIWXMAAAsSAAALEgHS3X78AAABMUlEQVRIS61UQZLEIAhs5h/z//v+ZZ4j7CGCDZJkszVUmTQ2oAgq75+P2RiADpgqoAMYCtMBTN15qE4856dt9iUc9s99TRU43VcTL8V+6Hu3lzHwQhWLD2B2jOAc22HS2YpMG6GfYwkISOacX2zDb4C4MldNGpcnsh9USgw5cZnDk0y6ALKHWwfCUyumYR6wAWbz9B17IRx7oVIBmWN+LZd8XWfAtii+U647KkHaRExRMpEQJ8ADRTfA9DD9a/X9gL1Al0WjQFvBsfMhTWFx11EJNkHThmjDbsh8m4xASBfiA4tA5BVxheKvpXlN0J6oYy6fDZB8raOKcV3w9h0LQ7I/Bl83o85b19PoemabdjwRIRB4Sfeo/F/qAs2CvQh9fao4R5ewXuZ2ktQLX2q+M/kFKvxUPbTMXhEAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13702",
    "data-name": "Group 13702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6135",
    "data-name": "Path 6135",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.86,104a.85.85,0,0,1-.07-1l24.3-49.88c.18-.39.51-.56.74-.4a.84.84,0,0,1,.06,1L19.6,103.6C19.41,104,19.08,104.15,18.86,104Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6136",
    "data-name": "Path 6136",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,52.72c.23-.16.56,0,.74.39L68.9,102.74a.81.81,0,0,1-.07,1c-.22.17-.55,0-.73-.39L44,53.71A.84.84,0,0,1,44,52.72Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13703",
    "data-name": "Group 13703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6135-2",
    "data-name": "Path 6135-2",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.76,104a.85.85,0,0,1-.07-1L131,53.12c.19-.39.52-.56.74-.4a.86.86,0,0,1,.07,1L107.51,103.6C107.32,104,107,104.15,106.76,104Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6136-2",
    "data-name": "Path 6136-2",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.92,52.72c.22-.16.55,0,.73.39l24.15,49.63a.83.83,0,0,1-.06,1c-.23.17-.56,0-.74-.39L131.85,53.71A.86.86,0,0,1,131.92,52.72Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17689",
    "data-name": "Rectangle 17689"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 15.89,
    y: 104.25,
    width: 56.06,
    height: 2.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17690",
    "data-name": "Rectangle 17690"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 103.8,
    y: 104.25,
    width: 56.06,
    height: 2.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17692",
    "data-name": "Rectangle 17692",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    width: 139,
    height: 6,
    transform: "translate(1.24 46.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAAAGCAYAAADzN235AAAACXBIWXMAAAsSAAALEgHS3X78AAABY0lEQVRIS81VS5YDIQgsvMucIreY+9+lshg/BWK3Jr2Yes+ICIh0Ee3n9UuaAVaA0uYCmNX5T89J7/ebH1P9HJfL80zGWDPqSm4XdSz3Nn3UfGgGAEMPAwwi13UqR18fhwe2Pa5MfRHXzkY2NcauDTDyqSCAghScZANFP+832US+Qkgt2a0FmT5wczYZ6hrtgMkmw8qE/UeuxIUMgLJYlelauYcj10VOh1iQJcBxRIrTCvOpviPegOh+pB9LH+86Kz+Edp2Sz8napYuOVTKmcf4/BllMZ7lE7VK67g4jdtouGOYdsJGoyhM7lGi6dXPISQ7R2P2bZMS/UB2dK9gh2Y7NAQZZ4oc7mYU47J0WSQXRo9rVGOF9XENjYRB7qkpi08mliB8dz2J6khgyffrAgB5eTt0tdYBh9xlKsXNR9iJtd/glahwXIosX7ThI6xBItV3IYKjLmyfJZ3t14Dd1eh4E8AY9FIeuyKsMTgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13712",
    "data-name": "Group 13712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 43.79,
    cy: 88.96,
    r: 11.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13709",
    "data-name": "Group 13709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_13",
    "data-name": "Union 13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44,91.73l-4.09-2.37h0L44,82.59v-.07l0,0,0,0v.07l4.16,6.79-.06,0-4.1,2.38v0h0Zm0-4.21v0h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_14",
    "data-name": "Union 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44,96l0,0V96l-4.1-5.68L44,92.66l4.13-2.39-4.1,5.67V96Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6138",
    "data-name": "Path 6138",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.34,86.48a.87.87,0,0,0-.83,0l-1.95,1.15-1.32.73-1.91,1.14a.87.87,0,0,1-.83,0L127,88.6a.83.83,0,0,1-.42-.72V86.14a.87.87,0,0,1,.42-.74l1.49-.86a.87.87,0,0,1,.83,0l1.5.9a.83.83,0,0,1,.41.73v1.15l1.32-.77V85.37a.87.87,0,0,0-.41-.73L129.37,83a1,1,0,0,0-.84,0l-2.84,1.68a.75.75,0,0,0-.42.69v3.27a.86.86,0,0,0,.42.73L128.5,91a.87.87,0,0,0,.83,0l1.91-1.11,1.32-.77L134.47,88a.89.89,0,0,1,.84,0l1.49.87a.84.84,0,0,1,.42.73v1.74a.83.83,0,0,1-.42.72l-1.46.87a.87.87,0,0,1-.83,0l-1.5-.86a.87.87,0,0,1-.41-.73V90.23l-1.32.77v1.14a.86.86,0,0,0,.41.73l2.82,1.63a.87.87,0,0,0,.83,0l2.82-1.63a.86.86,0,0,0,.41-.73v-3.3a.84.84,0,0,0-.42-.72Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17695",
    "data-name": "Rectangle 17695",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86,38h5.1a2.55,2.55,0,0,1,2.55,2.55h0a2.55,2.55,0,0,1-2.55,2.55H86a2.55,2.55,0,0,1-2.55-2.55h0A2.55,2.55,0,0,1,86,38Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_37",
    "data-name": "Line 37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 164.37,
    y: 202.82,
    width: 458.96,
    height: 1,
    transform: "translate(-41.46 119.87) rotate(-16.45)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideLiquidity);
export default __webpack_public_path__ + "static/media/ProvideLiquidity.393fdb84fc586cfe4222aec5c7c2810b.svg";
export { ForwardRef as ReactComponent };